export default "__VITE_ASSET__Csf29229__"